import { StyleSheet, Platform } from 'react-native';

import { Colors } from '../Themes';

export default StyleSheet.create({
  container: {
    borderRadius: 6.2,
    borderWidth: 1,
    borderColor: Colors.vfRed,
    marginHorizontal: 20,
    overflow: 'hidden',
    marginTop: 15.6,
    alignContent: 'flex-start',
    flexDirection: 'row',
  },
  header: {
    backgroundColor: Colors.vfRed,
    flex: 1,
    justifyContent: 'center',
    borderColor: Colors.vfRed,
  },
  textContainer: {
    flex: 5,
  },
  errorMessage: theme => ({
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
    color: theme.colors.errorMessageColor,
    marginHorizontal: 8,
    marginTop: 'auto',
    marginBottom: 'auto',
  }),

  warning: {
    width: 30,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginVertical: 12,
  },
});
